import { render, staticRenderFns } from "./DropdownV2Properties.vue?vue&type=template&id=1db231b4&"
import script from "./DropdownV2Properties.vue?vue&type=script&lang=js&"
export * from "./DropdownV2Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports